export default "__VITE_ASSET__CoCoaZIy__"